/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */

import { Component, ErrorInfo, ReactNode } from 'react';

import { Button } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';

import { ReactComponent as ErrorDarkImg } from 'assets/images/error-dark.svg';
import { ReactComponent as ErrorLightImg } from 'assets/images/error-light.svg';
import EmptyState from 'components/EmptyState';

interface Props {
  children: ReactNode;
}

interface State {
  hasError: boolean;
}

export default class ErrorBoundary extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      hasError: false,
    };
  }

  public static getDerivedStateFromError(_: Error): State {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  public componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    console.error('Uncaught error:', error, errorInfo);
  }

  public render() {
    const { hasError } = this.state;
    const { children } = this.props;

    if (hasError) {
      return <ErrorBoundaryFallbackComponent />;
    }

    return children;
  }
}

const ErrorBoundaryFallbackComponent = () => {
  const theme = useTheme();

  return (
    <EmptyState
      title="Algo inesperado aconteceu!"
      description={`"Nossa equipe técnica foi notificada da ocorrência"`}
      icon={
        theme.palette.type === 'dark' ? <ErrorDarkImg /> : <ErrorLightImg />
      }
    >
      <Button onClick={() => window.location.reload()}>
        Recarregar a página
      </Button>
    </EmptyState>
  );
};
